import styled, {css} from "styled-components"

import Card from "@irati/ui/src/Layout/Card"
import Flex from "@irati/ui/src/Flex"

const MAX_HEADER_WIDTH = "285px"

interface StyledProps {
  isSingleFlex: boolean
}

export const Wrapper = styled.div`
  padding: ${({theme}) => `${theme.spacing.oneAndHalf}`};
  border: 1px solid ${({theme}) => theme.colors.greys.darkGrey};
  border-radius: ${({theme}) => theme.spacing.half};
  margin-bottom: ${({theme}) => theme.spacing.four};
`

export const FlexCard = styled(Card)`
  flex-grow: 1;
  flex-basis: 0;
`

export const Header = styled.div`
  max-width: ${MAX_HEADER_WIDTH};
`

export const CenteredSelf = styled.div`
  align-self: center;
`

export const CenteredFlex = styled(Flex)<StyledProps>`
  ${({isSingleFlex, theme}) => isSingleFlex && css`
    margin: 0 auto ${theme.spacing.four};
    width: 50%;
  `}
`
